// Category colours shared by the globe (Three.js hex ints) and the product
// pages (CSS strings). Kept out of GlobeScene.js so pages that only need the
// palette don't pull in three.js.

// Slugs and hex values mirror the 13 rows seeded in backend/scripts/seed.js.
// Muted jewel tones rather than primaries: on a black globe, saturated neon
// reads as a dev demo. These stay distinguishable at pin scale while sitting
// comfortably beside the brand orange.
export const CATEGORY_COLORS = {
    // Niche taxonomy (finance / markets / economy / market-moving politics)
    markets: 0x4ade80,
    economy: 0x6b8fd4,
    'central-banks': 0xd4a843,
    policy: 0xe0656f,
    companies: 0xa88fd4,
    // Legacy general-news categories (inactive since 2026-09-27)
    breaking: 0xff4438,
    finance: 0xd4a843,
    government: 0x6b8fd4,
    economics: 0x8fbf7f,
    technology: 0x7c9fff,
    environment: 0x4fae7a,
    tourism: 0xff8a3d,
    crime: 0xc0392b,
    health: 0x5fc9d4,
    education: 0xa88fd4,
    sports: 0xf0a030,
    culture: 0xc98fd4,
    gossip: 0xe08fb0,
};

/** CSS colour string for a category slug. */
export const categoryCss = (slug) =>
    '#' + (CATEGORY_COLORS[slug] ?? 0x6b7280).toString(16).padStart(6, '0');
